import type { InsuranceIndex } from '../../../types/InsuranceFeatureConfig';
import type { ServicingFeatureConfig } from '../../../types/features/ServicingFeatureConfig';
import { servicing as base } from './base';
import { servicing as AT } from './AT';
import { servicing as CZ } from './CZ';
import { servicing as HR } from './HR';
import { servicing as HU } from './HU';
import { servicing as RO } from './RO';
import { servicing as RS } from './RS';
import { servicing as SK } from './SK';

export const servicingConfig: InsuranceIndex<ServicingFeatureConfig> = {
    base,
    AT,
    CZ,
    HR,
    HU,
    RO,
    RS,
    SK,
};
